import { Observable, of } from 'rxjs';
import { NotesRepository } from '../domain/notes/repository';

import HttpClient from '../utils/http-client';

export class NotesRepositoryImplementation extends NotesRepository {
    createNote(uid: string, cid: string | null, data: any): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.post(`/notes`, data);
    }

    getNotes(uid: string, cid: string | null): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.get(`/notes?page=1&limit=1000`);
    }

    getNoteDocuments(uid: string, cid: string | null, page = 1, limit = 20): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.get(`/notes/documents?page=${page}&limit=${limit}`);
    }

    getNoteDocumentItems(uid: string, cid: string | null, noteId: number): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.get(`/notes/documents/${noteId}`);
    }
}
